export default __webpack_public_path__ + "static/media/icon_intelligence_kinesthetic.1b62589a.svg";